import { AnimateOnScroll, AnimateOnScrollChild } from "./_transitions/animate_on_scroll";

const Card = ({ cardData, cardType }: { cardData: any, cardType: string }) => {
    if (!Array.isArray(cardData)) return null;
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';

    return (
        cardData.length === 0 ? null :
            <section className={`card-list ${cardType}`}>
                <div className="container">
                    <AnimateOnScroll transition=" ">
                        {cardData.map((item: any, index: number) => {
                            return (
                                <AnimateOnScrollChild delay={ (index * 200) } transition="slide-up" className="item" key={index}>
                                    <div className="icon"><img src={`${locateSrc}${item.icon?.url}`} alt={item.title || 'Card'} /></div>
                                    <h2>{item.title}</h2>
                                    <div className='dec'>{item.Content}</div>
                                </AnimateOnScrollChild>
                            );
                        })}
                    </AnimateOnScroll>
                </div>
            </section>
    );
};;

export default Card;
